var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-[calc(100vh-73px)] overflow-y-auto overflow-x-hidden"},[_c('div',{staticClass:"p-4 sm:p-7 min-h-screen"},[_c('Servers')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }